import { lang } from "../config/app.config";
import { httpbase } from "../utils/axios.utils";

export const fetchPageBySlug = async (slug:string) =>{
  try{
    const response = await httpbase().get(`page/${slug}?lang=${lang}`);
    return response.data.data;
  }catch(e:any){
    console.log(e);
  }
}